/*import {
    PAYMENT_SYSTEM_ID_CASH, PAYMENT_SYSTEM_ID_CARD, PAYMENT_SYSTEM_ID_SELF, PAYMENT_SYSTEM_ID_LINK, PAYMENT_SYSTEM_ID_LEGAL_ENTITY
} from '@/store/payment';*/
import {distance} from "@/utils/geo";
import Config from "@/config";
import store from "@/store";

export const DESTINATION_MSK = 85;
export const DESTINATION_SPB = 84;
export const DESTINATION_RUSSIA = 3;

export const DELIVERY_TYPE_COURIER_MSK = 1;
export const DELIVERY_TYPE_SELF = 2;
export const DELIVERY_TYPE_EXPRESS = 3;
export const DELIVERY_TYPE_COURIER_SPB = 4;

// todo забирать все из бэка

export const destinations = [
    {
        id: DESTINATION_MSK,// ID местоположения
        label: "Москва и обл.",
        city: "Москва",
        resolve: "Москва",
        mapCoords: [55.751244, 37.618423],
        /*deliveries: [
            {deliveryId: 6, zoneId: 101,},
            {deliveryId: 7, zoneId: 102,},
            {deliveryId: 8, zoneId: 103,},
            {zoneId: 104,},
        ],*/
        zones: [
            {
                id: 101,
                zIndex: 3,
                label: "Зона 1",
                coords: [[[55.77650194177001, 37.615569863223115], [55.77773323916321, 37.61708990711439], [55.772385218143796, 37.62478976057503], [55.770836990304126, 37.640582607254714], [55.75857009665068, 37.659260834491114], [55.768514532778894, 37.64813570784105], [55.75606206746588, 37.6615114868889], [55.752126069850895, 37.65978106476489], [55.74037938758099, 37.654946929501214], [55.72772672567114, 37.63154574881766], [55.72837940644474, 37.61255253051702], [55.73816578746874, 37.585273874273], [55.75129452577011, 37.58303153409818], [55.757937901924606, 37.58312319131157], [55.76084174307106, 37.57797335000369], [55.769358424455106, 37.5805482706575], [55.775445975592525, 37.58700918397214], [55.777814152847064, 37.593462853851356], [55.78048709039487, 37.59870182810594], [55.78077407612664, 37.60692812043803], [55.778100572230244, 37.61473505782019], [55.77599279007724, 37.61900538624655], [55.77367796574335, 37.62112261363875], [55.77464554454068, 37.624899163932184], [55.77650194177001, 37.615569863223115]]],
                price: null,
                number: 1,
            },
            {
                id: 102,
                zIndex: 2,
                label: "Зона 2",
                coords: [[[55.79215389436364, 37.65668085671495], [55.77941667322267, 37.675038908201714], [55.7687009968996, 37.69893587124118], [55.7393926571663, 37.70498005107754], [55.726301143843116, 37.70376074437229], [55.70276710376691, 37.668365440569644], [55.70024669137817, 37.66252895375341], [55.70153074848946, 37.64734530626765], [55.7003732804833, 37.62239476024671], [55.69945329303331, 37.611372768442706], [55.702118193078036, 37.60351200878196], [55.705607783560545, 37.586689193840826], [55.709697572777934, 37.56000280356252], [55.727500082767875, 37.53860584886891], [55.75236067479775, 37.527979734663255], [55.764401776573436, 37.53217070927279], [55.77249239841929, 37.54583251786658], [55.7856048798772, 37.56366707272247], [55.798860788622676, 37.58129235184578], [55.79686888624509, 37.594943774599265], [55.79732530998882, 37.615556872048415], [55.79215389436364, 37.65668085671495]]],
                price: null,
                number: 2,
            },
            {
                id: 104,
                zIndex: 1,
                label: "Зона 3",
                //coords: [[[55.581295520670444, 37.531976519097064], [55.64824628506749, 37.42651721277064], [55.72767791926474, 37.3736794250859], [55.78880072657061, 37.37386541712596], [55.83746454457925, 37.37542470018167], [55.90860385862066, 37.437699001298455], [55.919900087442066, 37.54066164935667], [55.88981336640495, 37.73566897357498], [55.82610094844054, 37.84874746747263], [55.665291872557695, 37.85700261013874], [55.615144349906025, 37.80530051838752], [55.576519481210696, 37.719833286361265], [55.581295520670444, 37.531976519097064]]],
                coords: [[[55.63784528612582, 37.45817752734365], [55.68132069870502, 37.41491886035146], [55.69063055041677, 37.412858923828026], [55.713507808447424, 37.38676639453117,],
                    [55.73482195565579, 37.37372012988273], [55.75225211431005, 37.366167029296776], [55.78708897931131, 37.36822696582021], [55.81416270829604, 37.39019962207023],
                    [55.839672055003966, 37.39706607714834], [55.848171437687824, 37.39019962207023], [55.86902564779209, 37.40873905078116], [55.88446596446298, 37.45062442675773],
                    [55.88716738594137, 37.482896765624915], [55.9049148873359, 37.52752872363273], [55.91224299808876, 37.58864017382802], [55.89874276804602, 37.641511877929595],
                    [55.893341354602086, 37.699876746093665], [55.82807898000372, 37.8344592656249], [55.79482625956552, 37.84132572070304], [55.71428307305827, 37.839952429687415],
                    [55.69063055041047, 37.82965274707022], [55.65648354380763, 37.84063907519523], [55.62269514146039, 37.79669376269522], [55.59432136568138, 37.734895666992095],
                    [55.574097333975104, 37.68271060839836], [55.574097333975104, 37.62571903124991], [55.583821732242036, 37.56048770800773], [55.596265432681975, 37.50555606738271]]],
                price: null,
                number: 3,
            },
        ],
        unknownZoneId: 103,
        unknownZonePricePerKm: null,
        unknownZonePricePerKmExpress: null,
        deliveryTypeIds: [DELIVERY_TYPE_COURIER_MSK, DELIVERY_TYPE_SELF],
        cityId: 533,    // для карты точек самовывоза
    },
    {
        id: DESTINATION_SPB,// ID местоположения
        label: "Санкт-Петербург и обл.",
        city: "Санкт-Петербург",
        resolve: "Санкт-Петербург",
        mapCoords: [59.938955, 30.315644],
        /*deliveries: [
            {deliveryId: 2, zoneId: 201,},
            {deliveryId: 4, zoneId: 202,},
            {deliveryId: 5, zoneId: 203,},
            {deliveryId: 10, zoneId: 204,},
            {deliveryId: 12, zoneId: 201,isExpress: true},
            {deliveryId: 13, zoneId: 202,isExpress: true},
            {deliveryId: 14, zoneId: 203,isExpress: true},
            {deliveryId: 15, zoneId: 204,isExpress: true},
        ],*/
        zones: [
            {
                id: 201,
                zIndex: 3,
                label: "Зона 1",
                coords: [[[59.97849596107258, 30.308780333943975], [59.97866188488103, 30.31346498534282], [59.97865574637506, 30.317720483299674], [59.978434529741996, 30.321460997125463], [59.979786452441665, 30.324406756042112], [59.982235113689406, 30.329841604924813], [59.98452586966066, 30.335532736761763], [59.98501021386384, 30.342425498237343], [59.97908989686737, 30.344615467199286], [59.97634443312616, 30.34493797548391], [59.973082472083135, 30.347663743045935], [59.966621938105945, 30.350353574683957], [59.963348161515775, 30.351698490502997], [59.96041837611023, 30.35407337458374], [59.95824482238949, 30.353616326165902], [59.95740549108826, 30.357794134925822], [59.95620026010351, 30.36179813654651], [59.9527908883679, 30.36055142743165], [59.95484852401575, 30.374840072931082], [59.95794899677312, 30.38055366267538], [59.959370002403446, 30.383324626859064], [59.959844080487926, 30.386438913796646], [59.95948643367858, 30.39508170281387], [59.95861895045745, 30.40000391214184], [59.95732101438919, 30.40406781458506], [59.95884571142665, 30.407863033744785], [59.959186866516, 30.415858771191537], [59.95104848492535, 30.41528722705866], [59.94680631456195, 30.41440064017292], [59.9427358490941, 30.41196910089464], [59.94333339902979, 30.440866753595795], [59.93737973989566, 30.441327159095767], [59.936238483075634, 30.435580103798465], [59.933460400831216, 30.435497873940573], [59.93518342996333, 30.442625421914737], [59.933891339297745, 30.445633096842013], [59.92102072765249, 30.43031952061009], [59.91785890312266, 30.4229631399038], [59.91586042430041, 30.414319298870435], [59.91993326489568, 30.399656654463303], [59.914218191739025, 30.36781743996029], [59.91410878850398, 30.361689880167802], [59.91486136847909, 30.35556232037529], [59.91636647706874, 30.343307200790317], [59.91319541231627, 30.33263994894187], [59.919074838283635, 30.326006739451948], [59.91631676319258, 30.318003027751473], [59.91610127887616, 30.30923756869077], [59.91588579319206, 30.297897188975842], [59.92219894244782, 30.29315504343745], [59.923470045202244, 30.299227564647175], [59.93122486782538, 30.2927902630114], [59.93380940453422, 30.29045137675034], [59.93637220392332, 30.288123219325485], [59.93574767449418, 30.283820956065668], [59.94918322069565, 30.267899363353145], [59.95105870270442, 30.26586088450192], [59.952125554211655, 30.265013306452957], [59.95319237128149, 30.26571068079695], [59.95584244865359, 30.264702170207325], [59.957028861101534, 30.2652386120105], [59.95905723170675, 30.266912310435472], [59.959880381071486, 30.269615977122914], [59.96184402050685, 30.273521273448523], [59.96308401210619, 30.274272291972625], [59.964237888723424, 30.274679987742886], [59.966185132164924, 30.280945628001714], [59.96851028763672, 30.282884518410263], [59.96984491227938, 30.283338979483712], [59.97109343240956, 30.284308424688028], [59.97234266701039, 30.287706436800523], [59.97324767591336, 30.291962755798234], [59.977555741102314, 30.303924021167727], [59.97849596107258, 30.308780333943975]], []],
                price: null,
                priceExpress: null,
                freeDeliveryAfter: null,
                freeExpressDeliveryAfter: null,
                number: 1,
            },
            {
                id: 202,
                zIndex: 2,
                label: "Зона 2",
                coords: [[[60.00393302219059, 30.327554976007775], [59.997310910424446, 30.361775277446416], [59.99251005191286, 30.416987269237552], [59.98789571008525, 30.458781760324577], [59.97660483003736, 30.458722028050353], [59.96571889526405, 30.457524579125312], [59.95586247054563, 30.46662681281747], [59.961541757185415, 30.48950971958419], [59.945351202238726, 30.505736201122318], [59.946118774576604, 30.54117384198701], [59.936723340925084, 30.53901764129897], [59.931247049046334, 30.53690310246773], [59.92645919316516, 30.53238530435911], [59.92149828450015, 30.527524183496674], [59.91550230101758, 30.525409644665455], [59.90379699042636, 30.526988404461225], [59.891742510442434, 30.524447291210123], [59.88572550568652, 30.498998492076815], [59.8817782744307, 30.471146433666178], [59.87284673662626, 30.436728327587083], [59.86158180019619, 30.403340189769697], [59.857070436142116, 30.385444491222337], [59.85394018174971, 30.366175501659306], [59.85192191189914, 30.336769918941346], [59.851713338074234, 30.290631924198685], [59.8772850292227, 30.294395902890415], [59.89915982146323, 30.22232326777286], [59.906265233097386, 30.20724240365688], [59.913713922150905, 30.21001432274397], [59.928606270394866, 30.210751642363547], [59.93238022779392, 30.19071793537181], [59.944077845131964, 30.17961061998165], [59.99010210865513, 30.184729426219928], [60.008329305817846, 30.20095142634203], [60.00420327570755, 30.233824580028553], [59.999045011724945, 30.28171810419843], [60.00393302219059, 30.327554976007775]], []],
                price: null,
                priceExpress: null,
                freeDeliveryAfter: null,
                freeExpressDeliveryAfter: null,
                number: 2,
            },
            {
                id: 203,
                zIndex: 1,
                label: "Зона 3",
                coords: [[[59.84255578942397, 30.512162711735527], [59.8316395443872, 30.52092517977063], [59.82692298264215, 30.516678472955583], [59.824971668998046, 30.50522198830843], [59.84235792670545, 30.465666525270844], [59.823970700503736, 30.470056374733467], [59.81577878961619, 30.397672311118143], [59.80613762724598, 30.40196384554203], [59.798742732662596, 30.40762867098147], [59.79796422697854, 30.324544564536165], [59.81114407406978, 30.27953772790485], [59.82779389920945, 30.241460458090838], [59.84849058205213, 30.130368428787104], [59.87311980044798, 30.155137727391114], [59.88071385567109, 30.175050447117595], [59.90762421054871, 30.175050447117595], [59.956500023492445, 30.175089840175072], [59.99024820287233, 30.16666481216494], [59.995015049686415, 30.16361024486689], [59.99823360549949, 30.17051203743217], [60.00604515597316, 30.165776193851727], [60.05753762841183, 30.223626077884802], [60.07100942748478, 30.290745676273676], [60.08134550462699, 30.35554784607329], [60.07040889155572, 30.395888269657238], [60.05013879404337, 30.454471469120246], [60.01700317501688, 30.496910989994316], [59.97070571559006, 30.54871371858863], [59.96481064886562, 30.55373926074547], [59.961416204982434, 30.553913573229117], [59.95776315687019, 30.552027949189327], [59.94692537627186, 30.5415619074082], [59.94029805974638, 30.53924777173672], [59.931395125077636, 30.53688273758523], [59.92240361475753, 30.527822909732652], [59.91731669440628, 30.52570259141426], [59.911194526396486, 30.525985532373316], [59.90466166479016, 30.526612112319047], [59.893637182732235, 30.52396572086757], [59.88575651242349, 30.525059367836505], [59.878132846295436, 30.52941458096715], [59.87084347904418, 30.532108021437168], [59.863466177101216, 30.52467344066729], [59.85880559860638, 30.515375882631524], [59.85479202400747, 30.506249985972804], [59.85360090701495, 30.50008923613932], [59.853424460627615, 30.495430523353715], [59.85194411264159, 30.495647861795184], [59.85120463731051, 30.49594826920479], [59.849795810226134, 30.495519115762523], [59.84853267300087, 30.497149898843364], [59.84255578942397, 30.512162711735527]], []],
                price: null,
                priceExpress: null,
                freeDeliveryAfter: null,
                freeExpressDeliveryAfter: null,
                number: 3,
            },
            /*{
                id: 204,
                label: "Зона 4",
                coords: null,
                price: 0, // на созвон
                priceExpress: 0 // на созвон
            }*/
        ],
        unknownZoneId: 204,
        unknownZonePricePerKm: null,
        unknownZonePricePerKmExpress: null,
        deliveryTypeIds: [DELIVERY_TYPE_COURIER_SPB, DELIVERY_TYPE_SELF, DELIVERY_TYPE_EXPRESS],
        cityId: 532,    // для карты точек самовывоза
    },
    {id: DESTINATION_RUSSIA, label: "Другой город"},
];

export const deliveryTypes = [
    {
        id: DELIVERY_TYPE_COURIER_MSK,
        label: "Доставка курьером",
        //paymentSystemIds: [PAYMENT_SYSTEM_ID_CASH, PAYMENT_SYSTEM_ID_CARD, PAYMENT_SYSTEM_ID_LEGAL_ENTITY]
    },
    {
        id: DELIVERY_TYPE_COURIER_SPB,
        label: "Доставка курьером",
        //paymentSystemIds: [PAYMENT_SYSTEM_ID_CASH, PAYMENT_SYSTEM_ID_CARD, PAYMENT_SYSTEM_ID_LEGAL_ENTITY]
    },
    {
        id: DELIVERY_TYPE_EXPRESS,
        label: "Экспресс-доставка",
        isExpress: true,
        //paymentSystemIds: [PAYMENT_SYSTEM_ID_CASH, PAYMENT_SYSTEM_ID_CARD, PAYMENT_SYSTEM_ID_LEGAL_ENTITY]
    },
    {
        id: DELIVERY_TYPE_SELF,
        label: "Самовывоз",
        isSelf: true,
        /**
         * В basket-form-payment.vue выбирается один из способов оплаты (по ссылке, наличными)
         * в зависимости от доступности в выбранном пункте назначения.
         * Доступность способа оплаты настраивается в админке в разделе "Настройки".
         */
        //paymentSystemIds: [PAYMENT_SYSTEM_ID_LINK, PAYMENT_SYSTEM_ID_SELF, PAYMENT_SYSTEM_ID_LEGAL_ENTITY]
    },
];

/**
 * Порог бесплатной доставки (сумма заказа) для выбранной зоны и типа доставки.
 * Задается правилом работы с корзиной "Бесплатная доставка" (приходит с бэкенда, см. App.vue).
 * null - зона не выбрана, самовывоз, либо для зоны порога нет.
 * @param form
 * @returns {number|null}
 */
export const freeDeliveryThreshold = (form) => {
    const deliveryType = deliveryTypes.find(el => el.id === form.deliveryTypeId);
    if (!deliveryType || deliveryType.isSelf) return null;

    const destination = store.state.destinations?.find(el => el.id === form.destinationId);
    const deliveryZone = destination?.zones?.find(el => el.id === form.deliveryZoneId);
    if (!deliveryZone) return null;

    return (deliveryType.isExpress ? deliveryZone.freeExpressDeliveryAfter : deliveryZone.freeDeliveryAfter) || null;
};

/**
 * null - не определено!
 * 0 - бесплатно!
 * значение - точная стоимость
 * @param form
 * @param orderSum сумма заказа для порога бесплатной доставки (см. mixins/free-delivery.js)
 * @returns {*}
 */
export const deliveryCost = (form, orderSum) => {
    let cost = form.deliveryCost = null;
    console.group("Расчет стоимости доставки");
    const deliveryType = deliveryTypes.find(el => el.id === form.deliveryTypeId);
    if (deliveryType) {
        console.log("Тип доставки", deliveryType.label);
        if (deliveryType.isSelf) cost = 0;
        else {
            const destination = store.state.destinations.find(el => el.id === form.destinationId);
            const deliveryZone = destination?.zones?.find(el => el.id === form.deliveryZoneId);
            if (deliveryZone) {
                console.log("Зона доставки: " + deliveryZone.label);

                // порог бесплатной доставки берется из правила работы с корзиной "Бесплатная доставка" (с бэкенда)
                const freeDeliveryAfter = freeDeliveryThreshold(form);
                const price = deliveryType.isExpress ? deliveryZone.priceExpress : deliveryZone.price;
                if (freeDeliveryAfter && orderSum >= freeDeliveryAfter) {
                    console.log("Доставка бесплатна: сумма заказа " + orderSum + " ₽ от " + freeDeliveryAfter + " ₽");
                    cost = 0;
                } else cost = price || null;
            } else if (form.deliveryCoords) {
                console.log("Точка за пределами обозначенных зон");
                const pricePerKm = deliveryType.isExpress ? destination.unknownZonePricePerKmExpress : destination.unknownZonePricePerKm;
                if (pricePerKm) {
                    //console.log("deliveryCoords", form.deliveryCoords);
                    // calc distance between deliveryCoords & closest point of last delivery zone
                    const lastZone = destination.zones[destination.zones.length - 1];
                    const plainCoords = list => {
                        return list.reduce((all, coords) => {
                            if (Array.isArray(coords) && Array.isArray(coords[0])) return [...all, ...plainCoords(coords)];
                            else if (Array.isArray(coords) && coords.length === 2) return [...all, coords];
                            return all;
                        }, []);
                    }
                    const zoneZoords = plainCoords(lastZone.coords);
                    //console.log("plain coords", zoneZoords);
                    let closestPoint = null, closestDistance = null;
                    zoneZoords.forEach(el => {
                        const d = distance(el, form.deliveryCoords);
                        //console.log("Distance between "+form.deliveryCoords+" & "+el+": "+d);
                        if (!closestDistance || d < closestDistance) {
                            closestDistance = d;
                            closestPoint = el;
                        }
                    });
                    closestDistance = Math.round(closestDistance / 100) / 10;
                    if (closestDistance >= Config.MAX_UNKNOWN_ZONE_DELIVERY_DISTANCE) {
                        console.log("Расстояние от точки до крайней зоны больше " + Config.MAX_UNKNOWN_ZONE_DELIVERY_DISTANCE + " км: " + closestDistance + " км");
                    } else {
                        const lastZoneCost = (deliveryType.isExpress ? lastZone.priceExpress : lastZone.price);
                        console.log("Стоимость доставки в последней зоне: " + lastZoneCost);
                        console.log("Расстояние от точки до крайней зоны: " + closestDistance + " км");
                        console.log("Стоимость за км: " + pricePerKm);
                        cost = Math.round(lastZoneCost + pricePerKm * closestDistance);
                    }
                } else console.log("Нет доставки за пределы известной зоны");
            }
        }
        if (cost === null) console.log("Стоимость доставки будет определена менеджером...");
        else console.log("Итого стоимость доставки: " + cost);
        form.deliveryCost = cost;
        console.groupEnd();
        return cost;

    }
    return null;
};